import React, {useState} from 'react';
import { useTranslation, Trans } from 'react-i18next';


const Experience = () => {
  const { t, i18n } = useTranslation();
  

  return (
    <div className='experience'>
      <h2 className='underline-title'>{t('experience.title')}</h2>
      <div className='content-block'>
        <p className='date'>{t('experience.1.date')}</p>
        <div className='content'>
          <h3 className='title'>{t('experience.1.title')}</h3>
          <p className='subtitle'>{t('experience.1.subtitle')}</p>
          <p className='text'>{t('experience.1.text')}</p>
        </div>
      </div>
      <div className='content-block'>
        <p className='date'>{t('experience.2.date')}</p>
        <div className='content'>
          <h3 className='title'>{t('experience.2.title')}</h3>
          <p className='subtitle'>{t('experience.2.subtitle')}</p>
          <p className='text'>{t('experience.2.text')}</p>
        </div>
      </div>
      <div className='content-block'>
        <p className='date'>{t('experience.3.date')}</p>
        <div className='content'>
          <h3 className='title'>{t('experience.3.title')}</h3>
          <p className='subtitle'>{t('experience.3.subtitle')}</p>
          <Trans
            i18nKey="experience.3.text"
            components={{ br: <br /> }}
          />
        </div>
      </div>
      <div className='content-block'>
        <p className='date'>{t('experience.4.date')}</p>
        <div className='content'>
          <h3 className='title'>{t('experience.4.title')}</h3>
          <p className='subtitle'>{t('experience.4.subtitle')}</p>
        </div>
      </div>
      <div className='content-block'>
        <p className='date'>{t('experience.5.date')}</p>
        <div className='content'>
          <h3 className='title'>{t('experience.5.title')}</h3>
          <p className='subtitle'>{t('experience.5.subtitle')}</p>
        </div>
      </div>
    </div>
  );
};

export default Experience;